import styled from "styled-components";
import CloseButton from "../closeButton";

export const VideoWrapper = styled.figure`
  border: ${({ $isSim }) => $isSim && "8px solid #eaf8fb"};
  border-radius: ${({ $isSim }) => $isSim && "18px"};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  .layer-icon {
    z-index: 100;
    cursor: pointer;
    width: 83px;
    @media screen and (max-width: 576px) {
      width: 50px;
    }
  }
  video {
    border-radius: 10px;
  }
`;

export const VideoCloseBtn = styled(CloseButton)`
  top: 20px;
  right: 20px;
  z-index: 100;
  width: fit-content;
  height: auto;
  @media screen and (max-width: 576px) {
    svg {
      width: 20px;
    }
  }
`;
